import React, { useEffect, useState, useContext } from 'react';
import { DContext } from '../../context/Datacontext';
import { TestFecthJobHistory } from '../services/TestFecthJobHistory';

export const TestFetchJobHistory = () => {
    const { BeURL, showAlert } = useContext(DContext);

    const [jobHistory, setJobHistory] = useState([]);
    const [search, setSearch] = useState("");

    useEffect(() => {
        TestFecthJobHistory({ BeURL, setJobHistory, showAlert });
    }, [BeURL , showAlert]);

    //Filter Logic
    const filteredJobs = jobHistory.filter((job) => {
        const name = job?.reportingTeamLead?.name?.toLowerCase() || "";
        const id = job?.reportingTeamLead?.id?.toLowerCase() || "";

        return (
            name.includes(search.toLowerCase()) ||
            id.includes(search.toLowerCase())
        );
    });

    //Download CSV
    const handleDownload = () => {
        const headers = ["Job Title", "Team Lead Name", "Team Lead ID" , "spoc"];

        const rows = filteredJobs.map((job) => [
            job?.title || "",
            job?.reportingTeamLead?.name || "",
            job?.reportingTeamLead?.id || "",
            job?.primaryRecruiter?.name || ""
        ]);

        let csvContent =
            "data:text/csv;charset=utf-8," +
            [headers, ...rows].map(e => e.join(",")).join("\n");

        const link = document.createElement("a");
        link.setAttribute("href", encodeURI(csvContent));
        link.setAttribute("download", "job_history.csv");
        document.body.appendChild(link);
        link.click();
    };

    console.log("jobHistory", jobHistory)

    return (
        <div style={{ padding: "20px" }}>
            {/* Search */}
            <input
                type="text"
                placeholder="Search by Team Lead Name or ID"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className='border rounded-lg'
                style={{
                    padding: "8px",
                    width: "300px",
                    marginBottom: "10px"
                }}
            />

            {/* 📥 Download */}
            <button className=' bg-primary-500 text-white font-semibold rounded-xl py-2 px-3' onClick={handleDownload} style={{ marginLeft: "10px" }}>
                Download CSV
            </button>

            {/* 📊 Table */}
            <table border="1" cellPadding="10" style={{ marginTop: "20px", width: "100%" }}>
                <thead>
                    <tr>
                        <th>Job Title</th>
                        <th>Team Lead Name</th>
                        <th>Team Lead ID</th>
                        <th>San Spoc Name</th>
                    </tr>
                </thead>
                <tbody>
                    {filteredJobs.length > 0 ? (
                        filteredJobs.map((job) => (
                            <tr key={job._id}>
                                <td className='text-center'>{job.title}</td>
                                <td className='text-center'> {job?.reportingTeamLead?.name}</td>
                                <td className='text-center'>{job?.reportingTeamLead?.id}</td>
                                <td className='text-center'>{job?.primaryRecruiter?.name}</td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="3" style={{ textAlign: "center" }}>
                                No Data Found
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};